<template>
  <div :class="{'list-view-filter-base': filterElement.isConfigured || isPreview}">
    <template v-if="filterElement.isConfigured">
      <label
        v-if="isLabelInBase"
        :for="filterElement.idForProp('filter')"
      >
        {{filterElement.label_title}}
      </label>
      <component
        v-if="getComponentByType(filterElement.filter_type)"
        :is="getComponentByType(filterElement.filter_type)"
        :filter-element="filterElement"
        :key="filterElement.id"
      ></component>
    </template>
    <filter-not-configured v-else-if="isPreview" :filter-element="filterElement"></filter-not-configured>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import filterElementBaseMixin from "../../../common/mixins/listViews/filterElementBaseMixin";
  import {ListViewFilterElementType} from "../../../common/enums/listViews/listViewFilterElementType";
  import ListViewFilterElementDefinition from "../../../common/models/listViews/elements/listViewFilterElementDefinition";
  import FilterElementDropdown from "./list-view-filter-dropdown.vue";
  import FilterElementSearchBar from "./list-view-filter-search-bar.vue";
  import FilterElementDateRange from "./list-view-filter-date-range.vue";
  import FilterElementToggle from "./list-view-filter-toggle.vue";
  import FilterElementGrid from "./list-view-filter-grid.vue";
  import {ListViewFilterElementCapability} from "../../../common/models/listViews/elements/listViewFilterElementCapability";
  import {ListViewFilterControlElementType} from "../../../common/enums/listViews/listViewFilterControlElementType";
  import FilterNotConfigured from "./list-view-filter-not-configured.vue"

  export default Vue.extend({
    components: {
      'filter-dropdown': FilterElementDropdown,
      'filter-search-bar': FilterElementSearchBar,
      'filter-date-range': FilterElementDateRange,
      'filter-toggle': FilterElementToggle,
      'filter-grid': FilterElementGrid,
      'filter-stack': FilterElementGrid, // stacks are fundamentally grids
      FilterNotConfigured,
    },
    mixins: [
      filterElementBaseMixin,
    ],
    data: function () {
      return {};
    },
    computed: {
      isPreview(): boolean {
        return !this.selectedPublishedListView;
      },
      isLabelInBase(): boolean {
        return this.filterElement.can(ListViewFilterElementCapability.labelable) && this.filterElement.isNot(ListViewFilterControlElementType.Toggle);
      },
    },
    methods: {
      getComponentByType(filterType: ListViewFilterElementType): string {
        return ListViewFilterElementDefinition.getFilteringComponent(filterType);
      },
    }
  });
</script>